(function() {
    "use strict";

    angular
        .module('ccsTrApp')
        .service('XLSXExportService', XLSXExportService);

    XLSXExportService.$inject = ['$rootScope', '$http'];

    function XLSXExportService( $rootScope, $http ) {
        return {
            downloadShipmentBoeXLSX: downloadShipmentBoeXLSX,
            downloadShipmentBoeApplicationXLSX: downloadShipmentBoeApplicationXLSX,
            downloadJapanInvoicesReport: downloadJapanInvoicesReport,
            downloadBookedContractsReport: downloadBookedContractsReport,
            downloadShipmentReport: downloadShipmentReport,
            downloadInvoiceReport: downloadInvoiceReport,
            downloadGrossEstimateContractsReport: downloadGrossEstimateContractsReport,
            downloadExistingContractsReport: downloadExistingContractsReport,
            downloadFixationReport: downloadFixationReport,
            downloadFixationUsageReport: downloadFixationUsageReport
        };

        function downloadShipmentBoeXLSX( id ) {
            var url = "api/shipments/xlsx/billOfExchange/" + id;
            return $http.get( url, {responseType: 'arraybuffer'});
        }

        function downloadShipmentBoeApplicationXLSX(id, negotiation, cif, obl) {
            var url = "api/shipments/xlsx/billOfExchange/application/" + id + "?negotiation=" + negotiation + "&cif=" + cif + "&obl=" + obl;
            return $http.get( url, {responseType: 'arraybuffer'});
        }

        function downloadJapanInvoicesReport( startDate, endDate ) {
            var url = "api/invoices/japan/report/download?startDate=" + startDate + "&endDate=" + endDate;
            return $http.get(url, {responseType: 'arraybuffer'});
        }

        function downloadBookedContractsReport(startDate, endDate, contractType, contractStatus) {
            var url = "api/contracts/booked/download?startDate=" + startDate + "&endDate=" + endDate +
                "&purchase=" + contractType.purchase + "&sale=" + contractType.sale +
                "&draft=" + contractStatus.draft + "&issued=" + contractStatus.issued + "&complete=" + contractStatus.complete +
                "&signed=" + contractStatus.signed + "&cancelled=" + contractStatus.cancelled;
            return $http.get(url, {responseType: 'arraybuffer'});
        }

        function downloadShipmentReport(list) {
            var url = "api/shipments/report/download";
            return $http({
                url: url,
                method: 'POST',
                data: list,
                headers: {'Content-Type': 'application/json'},
                responseType: 'arraybuffer'
            });
        }

        function downloadInvoiceReport(list) {
            var url = "api/invoices/report/download";
            return $http({
                url: url,
                method: 'POST',
                data: list,
                headers: {'Content-Type': 'application/json'},
                responseType: 'arraybuffer'
            });
        }

        function downloadGrossEstimateContractsReport(list) {
            var url = "api/contracts/gross-estimate/download";
            return $http({
                url: url,
                method: 'POST',
                data: list,
                headers: {'Content-Type': 'application/json'},
                responseType: 'arraybuffer'
            });
        }

        function downloadExistingContractsReport(params) {
            var url = "api/existingContractReportDTO";
            return $http({
                url: url,
                method: 'GET',
                params: params,
                responseType: 'arraybuffer'
            });
        }

        function downloadFixationReport(params) {
            var url = "api/management/fixation/download";
            return $http({
                url: url,
                method: 'GET',
                params: params,
                responseType: 'arraybuffer'
            });
        }

        function downloadFixationUsageReport(id) {
            var url = "api/management/fixation/" + id + "/usage/download";
            return $http.get( url, {responseType: 'arraybuffer'});
        }
    }
})();
